import React, { useEffect, useState } from "react";
import styling from "./RegisterOptions.module.css";
import image from "../../assets/RegisterOptions1.svg";
import { Link, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import firebase from "../../firebase/firebase";
import { notify, ToastContainer } from "../Notify/Notify";
import {
  userDetails,
  salesChannelAction,
  salesItem,
  allCustomers,
  shopDetails,
} from "../../redux/actions/actions";
import Navbar from "../Home/Navbar/Navbar";
function RegisterOptions() {
  let [passcode, setPasscode] = useState("");
  let [shops, setShops] = useState([]);
  let [shopName, setShopName] = useState("");
  let shopDetailsLocal = useSelector((state) => state.shopDetails);
  let loggedIn = useSelector((state) => state.isLogged);
  let userDetailsLocal = useSelector((state) => state.user);

  let dispatch = useDispatch();

  useEffect(() => {
    // GET ALL SHOPS NAME

    const db = firebase.firestore();
    db.collection("shops")
      .get()
      .then((res) => {
        let ans = res.docs.map((doc) => {
          return `${doc.data().shopDetails.shopName}, ${
            doc.data().shopDetails.shopPhone
          }`;
        });
        setShops(ans);
      })
      .catch((err) => {
        alert("ERROR");
      });
  }, []);

  // useEffect(() => {
  //   if (userDetailsLocal.shopName) {
  //     setShopName(userDetailsLocal.shopName);
  //   }
  // }, [userDetailsLocal]);

  if (!loggedIn) {
    return <Redirect to="signin" />;
  } else if (Object.keys(shopDetailsLocal).length !== 0) {
    return <Redirect to="/dashboard" />;
  }
  let checkPasscode = () => {
    if (shopName && passcode) {
      // CHECKING PASSCODE
      const db = firebase.firestore();
      db.collection("shops")
        .doc(shopName)
        .get()
        .then((doc) => {
          if (doc.data().shopDetails.shopOwnerPasscode === passcode) {
            notify("success", "user login successfully");
            console.log("LOGIN SUCCES AS A EMPLOYEE");
            // dispatch(userDetails());
            dispatch(shopDetails(doc.data().shopDetails));
            dispatch(salesChannelAction(doc.data().userSalesChannels));
            dispatch(salesItem(doc.data().products));
            dispatch(allCustomers(doc.data().customers));
          } else {
            console.log("fail");
            notify("error", "Please enter the correct passkey");
          }
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
        });
      // UPDATE USER STATUS
      db.collection("users")
        .doc(userDetailsLocal.id)
        .update({
          ...userDetailsLocal,
          status: "employee",
          shopName,
          passcode,
        })
        .then(() => {
          dispatch(
            userDetails({
              ...userDetailsLocal,
              status: "employee",
              shopName,
              passcode,
            })
          );
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
        });
    } else {
      notify("error", "Please select shop name and enter passkey");
    }
  };

  return (
    <div className={styling.RegisterOptionsPage}>
      <Navbar hideAllOptions={true} />

      <div className={styling.RegisterOptions}>
        <div className={styling.RegisterOptionsCard}>
          {/* Left: illustration + intro */}
          <div className={styling.RegisterOptionsContent}>
            {/* <p className={styling.badge}>Get started</p> */}
            <h1 className={styling.heading}>
              How do you want to access ShopManager?
            </h1>
            <p className={styling.subtitle}>
              Register a new shop as an owner, or join an existing shop using
              the passcode shared with you.
            </p>
            <img src={image} alt="Access options" />
          </div>

          {/* Right: options */}
          <div className={styling.RegisterOptionsTextArea}>
            {/* Owner block */}
            <div className={styling.optionBlock}>
              <div className={styling.optionHeader}>
                <h3>Shop Owner</h3>
                <p>
                  Set up your store, manage inventory, and control employee
                  access.
                </p>
              </div>
              <Link to="/register" className={styling.primaryButton}>
                Continue as Admin (Owner)
              </Link>
            </div>

            <div className={styling.divider}>
              <span>or</span>
            </div>

            {/* Employee block */}
            <div className={styling.optionBlock}>
              <div className={styling.optionHeader}>
                <h3>Employee</h3>
                <p>
                  Select your shop and enter the passcode given by your shop
                  owner.
                </p>
              </div>

              <div className={styling.inputGroup}>
                <label className={styling.fieldLabel}>Shop</label>
                <select
                  value={shopName}
                  onChange={(e) => setShopName(e.target.value)}
                >
                  <option value="" disabled>
                    Select shop
                  </option>
                  {shops.map((eachItem) => (
                    <option value={eachItem.split(",")[0]} key={eachItem}>
                      {eachItem}
                    </option>
                  ))}
                </select>
              </div>

              <div className={styling.inputGroup}>
                <label className={styling.fieldLabel}>Passkey</label>
                <input
                  type="password"
                  value={passcode}
                  onChange={(e) => setPasscode(e.target.value)}
                  placeholder="Enter passkey"
                />
              </div>

              <button
                onClick={checkPasscode}
                className={styling.secondaryButton}
              >
                Enter as Employee
              </button>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}

export default RegisterOptions;
